module.exports = __webpack_public_path__ + "img/x2.7673495b.jpg";